/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InstantGameType = {
    _11184809: '11184809',
    PULL_TAB: 'PULL_TAB',
    SCRATCH: 'SCRATCH',
    ONLINE: 'ONLINE',
    unknown_default_open_api: '11184809'
} as const;
export type InstantGameType = typeof InstantGameType[keyof typeof InstantGameType];


export function instanceOfInstantGameType(value: any): boolean {
    for (const key in InstantGameType) {
        if (Object.prototype.hasOwnProperty.call(InstantGameType, key)) {
            if (InstantGameType[key as keyof typeof InstantGameType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InstantGameTypeFromJSON(json: any): InstantGameType {
    return InstantGameTypeFromJSONTyped(json, false);
}

export function InstantGameTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstantGameType {
    return json as InstantGameType;
}

export function InstantGameTypeToJSON(value?: InstantGameType | null): any {
    return value as any;
}

